export function onHoverFilter({ isHovered }: { isHovered: boolean }) {
    return isHovered ? 'blur(4px)' : 'unset';
}
